import * as React from "react";

interface CommonProps {
}

export class ActionsCommon extends React.Component<CommonProps, {}> {
    public render() {
        return <div id="actions-common">{this.props.children}</div>;
    }
}

interface PrimaryProps {
}

export class ActionsPrimary extends React.Component<PrimaryProps, {}> {
    public render() {
        return <div id="actions-primary">{this.props.children}</div>;
    }
}

interface SecondaryProps {
}

export class ActionsSecondary extends React.Component<SecondaryProps, {}> {
    public render() {
        return <div id="actions-secondary">{this.props.children}</div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/admin/Actions.tsx